import { InMemoryCache } from '@apollo/client';

const defaultConnection = {
  edges: [],
  pageInfo: { endCursor: null, hasNextPage: false },
};

const dedupeNodeRefs = (existing: any[], incoming: any[]) => {
  const seen = new Set(existing.map((r: any) => r?.__ref));
  const added = incoming.filter((r: any) => {
    const ref = r?.__ref;
    if (!ref || seen.has(ref)) return false;
    seen.add(ref);
    return true;
  });
  return [...existing, ...added];
};

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        sparks: {
          keyArgs: ['filter', 'lifespanStage', 'sparkCategoryIds'],
          merge(existing = defaultConnection, incoming) {
            // Support both old (items/nextCursor) and new (edges/pageInfo) shapes
            const existingRefs = Array.isArray(existing.items)
              ? existing.items
              : (existing.edges || []).map((e: any) => e?.node).filter(Boolean);
            const incomingRefs = Array.isArray(incoming.items)
              ? incoming.items
              : (incoming.edges || []).map((e: any) => e?.node).filter(Boolean);
            const mergedNodeRefs = dedupeNodeRefs(existingRefs, incomingRefs);

            // Prefer to store in new (edges/pageInfo) shape
            const endCursor = incoming?.pageInfo?.endCursor ?? incoming?.nextCursor ?? null;
            const hasNextPage = incoming?.pageInfo?.hasNextPage ?? Boolean(endCursor);
            return {
              edges: mergedNodeRefs.map((nodeRef: any) => ({ __typename: 'SparkEdge', node: nodeRef })),
              pageInfo: { endCursor, hasNextPage },
            };
          },
        },
      },
    },
  },
  //     comments: {
  //       keyArgs: ['sparkId', 'parentId'],
  //       merge(existing = defaultEdges, incoming, { args, cache }) {
  //         const { parentId } = args || {};

  //         if (parentId) {
  //           // This handles replies
  //           const parentRef = cache.identify({ __typename: 'Comment', id: parentId });
  //           if (parentRef) {
  //             cache.modify({
  //               id: parentRef,
  //               fields: {
  //                 replies(existingReplies = defaultEdges) {
  //                   const updatedEdges = deduplicateEdges(
  //                     existingReplies.edges,
  //                     incoming.edges || [],
  //                   );
  //                   return {
  //                     ...incoming,
  //                     edges: updatedEdges,
  //                   };
  //                 },
  //               },
  //             });
  //           }
  //           return existing; // Don't store in Query.comments
  //         }

  //         // Top-level comments
  //         const edges = deduplicateEdges(existing.edges, incoming.edges || []);
  //         return { ...incoming, edges };
  //       },
  //       read(existing) {
  //         return existing || defaultEdges;
  //       },
  //     },
  //   },
  // },
  // Comment: {
  //   fields: {
  //     replies: {
  //       keyArgs: false,
  //       merge(existing = defaultEdges, incoming) {
  //         const edges = deduplicateEdges(existing.edges, incoming.edges || []);
  //         return { ...incoming, edges };
  //       },
  //       read(existing) {
  //         return existing || defaultEdges;
  //       },
  //     },
  //   },
  // },
  // },
});

export default cache;
